export const typography = {
  primaryFontFamily: "system-ui, sans-serif",
}
